import React from 'react';

import { Container, Badge, } from 'react-bootstrap';
import { Table } from '../../components/DataTable';

import { Column } from 'react-table';

import { LeaderboarType } from "../../model/index"




import { useAsync, } from 'react-use';
import api from '../../api';



import classNames from 'classnames/bind';
import style from './index.module.css';
const cx = classNames.bind(style);


function useLeaderboard(cu_id: string) {
  const { loading, value } = useAsync(() => api.getLeaderBoard({
    cu_id
  }), []);


  return {
    loading,
    value,
    error: value?.err
  };
}

export interface LeaderboardProps {
  cuid: string,
  campaignName: string | null;
  userName: string;
}
const numberFormatter = (value: string) =>
  (+value).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
const Leaderboard: React.FC<LeaderboardProps> = ({
  cuid,
  campaignName,
  userName
}) => {
  const { loading: LeaderboardLoading, value, } = useLeaderboard(cuid)

  React.useEffect(() => { (window.parent as any).resizeIframe() }, [value])

  const leaderboard_columns = React.useMemo<Column<LeaderboarType>[]>(
    () => {
      const baseColumns: Column<LeaderboarType>[] = [
        {
          Header: "排名",
          accessor: "ranking",
          disableSortBy: true
        },
        {
          Header: "排名變化",
          accessor: "rank_prev",
          disableSortBy: true,
          Cell: cellInfo => <>
            <div className={cx("tablewrap", cellInfo.cell.row.original.rank_prev === 0 || cellInfo.cell.row.original.rank_prev === 65535 ? "" : cellInfo.cell.row.original.rank_prev >= 1 ? "rank_up" : "rank_down")}>{cellInfo.cell.row.original.rank_prev === 65535 ? "--" : cellInfo.cell.row.original.rank_prev}</div>
          </>
        },
        {
          Header: "玩家名稱",
          accessor: "user_name",
          disableSortBy: true
        },
        {
          Header: "投組淨值",
          accessor: "nav",
          disableSortBy: true,
          Cell: cellInfo => <>
            {<div>{numberFormatter(cellInfo.cell.row.original.nav.toString())}</div>}
          </>
        },
        {
          Header: "報酬率",
          accessor: "roi",
          disableSortBy: true,
          Cell: cellInfo => <>
            {<div>{cellInfo.cell.row.original.roi.toFixed(2)}％</div>}
          </>
        }
      ];

      if (campaignName === '權校大比拚') {
        baseColumns.splice(3, 0, {
          Header: "就讀學校",
          accessor: "school_name",
          disableSortBy: true
        });
      }

      return baseColumns;
    },
    [campaignName] 
  );

  return (
    <div className={cx('container')}>
      <div className={cx("page-Leaderboardt")}>
        <Container className={cx("container-left")} fluid>
          <div className={cx("text-color", " container-left")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="text-color bi bi-play" viewBox="0 0 16 16">
              <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
            </svg>
            目前盤別：{campaignName ? campaignName : "尚未選擇活動"}
          </div>
          <div className={cx("text-color", "container-left")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className={cx("text-color", "bi", "bi-play")} viewBox="0 0 16 16">
              <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
            </svg>
            排行榜
            <span className={cx("badge-username")} >{userName}</span>
          </div>
          <div className={cx("updateTime")}>更新時間：{value?.rank_date || ""}</div>
          <Table columns={leaderboard_columns} data={value?.leaderboard || []} loading={LeaderboardLoading} pagination={true} />
          <ul className={cx("text-secondary", "small")} style={{ marginBottom: "0" }}>  Tip:</ul>
          <ul className={cx("list-decimal", "text-secondary", "small")}>
            <li>「投組淨值」計算公式：投組淨值=[現金資產] + [庫存部位價值=SUM每檔商品(現價×張數×1000)]。</li>
            <li>「報酬率」計算公式：報酬率=[投組淨值-(初始金額+入金)] / (初始金額+入金)。</li>
          </ul>
        </Container>
      </div >
    </div>
  );
};

export default Leaderboard;